import { Button } from '@repo/ui/components/ui/button'
import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeftIcon, HomeIcon } from 'lucide-react'
import { WebLayout } from '@/components/layout'

export const Route = createFileRoute('/404')({
  component: NotFoundPage,
})

export function NotFoundPage() {
  return (
    <WebLayout centered>
      <section className="flex w-full max-w-2xl flex-col items-center gap-8 text-center">
        <div className="relative">
          <h1 className="text-9xl font-bold text-muted-foreground/20">404</h1>
        </div>

        <div className="space-y-4">
          <h2 className="text-4xl font-bold tracking-tight">Page not found</h2>
          <p className="mx-auto max-w-md text-lg text-muted-foreground">
            The page you're looking for doesn't exist. It might have been moved, deleted, or the URL
            might be incorrect.
          </p>
        </div>

        <div className="flex flex-col justify-center gap-3 pt-4 sm:flex-row">
          <Button asChild variant="default" size="lg">
            <Link to="/">
              <HomeIcon className="mr-2 h-4 w-4" />
              Go to Homepage
            </Link>
          </Button>
          <Button variant="outline" size="lg" type="button" onClick={() => window.history.back()}>
            <ArrowLeftIcon className="mr-2 h-4 w-4" />
            Go Back
          </Button>
        </div>
      </section>
    </WebLayout>
  )
}
